import type { ExitManagementState } from './types';

export const createEmptyExitState = (): ExitManagementState => ({
  companies: {},
  funds: {},
  opportunities: {},
  projects: {},
  buyers: {},
  transactions: {},
  conditions: {},
  paymentPlans: {},
  paymentRecords: {},
  risks: {},
  tasks: {},
  activities: [],
});
